import React from 'react';
import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import blueSunglassesDudes from 'images/characters/blue-sunglasses-dudes.svg';

const StyledImg = styled.img`
  width: 50%;
  margin-bottom: 2rem;
  margin-top: 3rem;
`;
const MissingGraph = ({ name }) => (
  <Flex direction='column'>
    <StyledImg src={blueSunglassesDudes} />
    <Text size='large' width='80%'>
      {name} can be viewed only when filtering by all teams or a selected
      repository
    </Text>
  </Flex>
);

export default MissingGraph;
